import React, { useState } from 'react';
import { connect } from 'react-redux';

import ForgotPasswordView from 'views/ForgotPassword';
import UserService from 'api/User';
import SettingsActions from 'store/reducers/Settings';
import { useSubmit } from 'hooks';

const ForgotPassword = ( { toggleLoading } ) => {
  const [dataSubmitted, setDataSubmitted] = useState( false );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => UserService.recoverPassword( dataToSend ),
    toggleLoading,
    callback: () => setDataSubmitted( true ),
  } );

  return (
    <ForgotPasswordView
      dataSubmitted={dataSubmitted}
      onSubmit={submitForm}
    />
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( ForgotPassword );
